import React, { useState, useEffect } from "react";
import { Card, Button, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import EditablePrice from "./Backend/EditOximoPrice";

// Load API URL from environment variables
const API_BASE_URL = process.env.REACT_APP_API_URL;

const OximoProductCard = ({ product }) => {
  const [updatedPrice, setUpdatedPrice] = useState(null);

  // Fetch latest product details
  const fetchLatestPrice = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}api/oximo/${product.symbol}/?timestamp=${new Date().getTime()}`);
      console.log("✅ Fetched latest product data:", response.data);
      setUpdatedPrice(response.data.price); // Update state with the latest price
    } catch (error) {
      console.error("Error fetching latest product data:", error);
    }
  };

  // Fetch updated product data on page load
  useEffect(() => {
    setUpdatedPrice(product.price); // Ensure initial price is set
    fetchLatestPrice();
  }, [product.symbol]); // Fetch only when symbol changes

  // Function to handle price updates from EditablePrice
  const handlePriceUpdate = (newPrice) => {
    console.log("✅ Updating price in parent:", newPrice);
    setUpdatedPrice(newPrice);
  };

  return (
    <Col md={4} className="mb-4">
      <Card className="shadow">
        <Card.Img variant="top" src={product.foto_1} alt={product.symbol} />
        <Card.Body>
          <Card.Title>{product.short_name_en}</Card.Title>
          <Card.Text>
            <strong>Price:</strong> {updatedPrice ? `₦${updatedPrice}` : "No price"}
            <EditablePrice
              initialPrice={updatedPrice}
              symbol={product.symbol}
              onPriceUpdate={handlePriceUpdate}
            />
          </Card.Text>
          <Link to={`/product/${product.symbol}`}>
            <Button variant="primary">View More Details</Button>
          </Link>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default OximoProductCard;
